import { useEffect } from 'react';
import { Accessibility } from 'accessibility';
// import accessable from '../lib/assets/accessable.svg'


export default function AccessibilityIcon() {
    useEffect(() => {
        // Initialize with custom icon
        const options = {
            icon: {
                // Path to your custom SVG
                // img: ['accessibility' / 'accessable']
            },
            hotkeys: {
                enabled: true,
                helpTitles: true
            },
            session: {
                persistent: true
            },
            modules: {
                increaseText: true,
                decreaseText: true,
                invertColors: true,
                grayHues: true,
                underlineLinks: true,
                bigCursor: true,
                readingGuide: true,
                textToSpeech: true,
                speechToText: true
            }
        };

        // Initialize the accessibility component with options
        const accessibility = new Accessibility(options);

        return () => {
            // Clean up if needed
        };
    }, []);

    // This component doesn't render anything visible
    return null;
} 